module.exports = __webpack_public_path__ + "img/Social_7.edfa656d.webp";